export default "/StatisticheIsaWeb/dist/pdf/NTM_Internet_Multianno.pdf";